import React from "react";

export default function PortalHeading({ title, subtitle, onBack }) {
  return (
    <header className="rma-nc-heading">
      {onBack ? (
        <button type="button" className="rma-nc-backlink" onClick={onBack}>
          &larr; All cases
        </button>
      ) : null}
      <h1 className="rma-nc-heading-title">{title}</h1>
      <p className="rma-nc-heading-subtitle">{subtitle}</p>
    </header>
  );
}
